import React, { createContext, useContext, useState, ReactNode } from "react";

export interface User {
  id: string;
  name: string;
  email: string;
  role: "admin" | "user";
}

interface UserContextType {
  users: User[];
  addUser: (user: Omit<User, "id">) => void;
  removeUser: (id: string) => void;
  updateUser: (id: string, user: Partial<User>) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [users, setUsers] = useState<User[]>([]);

  const addUser = (user: Omit<User, "id">) => {
    const newUser: User = {
      ...user,
      id: Date.now().toString(),
    };
    setUsers((prev) => [...prev, newUser]);
  };

  const removeUser = (id: string) => {
    setUsers((prev) => prev.filter((user) => user.id !== id));
  };

  
  const updateUser = (id: string, userData: Partial<User>) => {
  setUsers(prevUsers => 
    prevUsers.map(user => 
      user.id === id ? { ...user, ...userData } : user
    )
  );
};

  return (
    <UserContext.Provider value={{ users, addUser, removeUser, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUsers must be used within a UserProvider");
  }
  return context;
};
